WiseMetering.Model.OrganizationLog = WiseMetering.Model.extend({
    urlRoot: '/organization_logs'
});
